export default "__VITE_ASSET__DFJ79Bab__"